import { Outlet } from "react-router";

export function DeliveryRoute() {
  return <Outlet />;
}
